module.exports = __webpack_public_path__ + "static/media/arrow--left--white.5d54d4eb.svg";